import { type } from '@ngrx/signals'
import { eventGroup } from '@ngrx/signals/events'

import type { ConversationProfile } from '@app/modules/messaging/models/conversation-profile.model'
import type { MessageForm } from '@app/modules/messaging/models/message-form.model'
import type { S3BatchFileUpload } from '@app/modules/s3-upload/core/s3-batch-file-upload'

import type { MessagePhotoAlbumPhoto } from '../models/message-photo-album-photo.model'

export const photoUploadEvents = eventGroup({
  source: 'Photo Upload',
  events: {
    uploadStart: type<void>(),
    uploadComplete: type<{
      batchUpload: S3BatchFileUpload
      photos: MessagePhotoAlbumPhoto[]
      profile: ConversationProfile
      messageForm: MessageForm | undefined
    }>(),
    uploadEnd: type<void>(),
  },
})
